import { Component, h, Watch, Prop } from '@stencil/core';
import _ds from '../../../typescript/dot-stash';
import CssClassList from '../../types/css-class-list.interface';

@Component({
  tag: 'ds-link',
  styleUrl: 'link.scss'
})
export class DSLink {
  
  @Prop() mods: string | string[] = "default";

  CSSClassList: CssClassList;
  blockName = "ds-link";

  @Watch('mods')
  modsChangeHandler( newMods ) {
    this.CSSClassList = _ds.props.toClassList("ds-link", newMods);
  }

	componentWillLoad() {
		this.CSSClassList = _ds.props.toClassList("ds-link", this.mods);
	}

  render() {
		return (
			<div
				class={{
					...this.CSSClassList,
				}}
			>
        <div class={`${this.blockName}__content`}>
				  <slot />
        </div>
			</div>
    );
  }
}